var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"clear"},[_c('FormList',{attrs:{"list":_vm.formList,"data":_vm.formData,"onChange":_vm.onInputChange}}),_c('div',{staticClass:"button",on:{"click":function($event){return _vm.handleClick('copyClear')}}},[_vm._v("\n    抄税清卡\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }